export default {
 pageTitle: 'ODI境外投资备案',
 heroTag: '境外投资备案服务',
 heroDesc: '专业办理ODI境外投资备案，协助企业合法合规开展境外投资业务，为企业出海保驾护航',
 emailConsultation: '邮件咨询',
 learnProcess: '了解办理流程',
 whatIsTitle: '什么是ODI境外投资备案？',
 whatIsPara1: 'ODI（Outbound Direct Investment）境外投资备案，是指中国境内企业直接或通过其控制的境外企业，以新建、并购等方式在境外设立非金融企业或取得既有非金融企业所有权、控制权、经营管理权等权益的行为。',
 whatIsPara2: '根据中国相关法律法规，企业开展境外投资前，需要完成商务部门、发改委、外汇管理局等部门的备案或核准手续，确保投资行为合法合规。',
 whatIsPara3: '我们提供一站式ODI备案服务，协助企业顺利完成各项审批手续，让您的境外投资之路畅通无阻。',
 whyNeedTitle: '为什么需要ODI备案？',
 whyNeedSubtitle: '合规开展境外投资的必要条件',
 reason1Title: '合法合规',
 reason1Desc: '满足国家外汇管理和境外投资管理要求，避免违规风险',
 reason2Title: '资金出境',
 reason2Desc: '获得外汇管理部门批准，合法办理投资资金的跨境汇款',
 reason3Title: '税务优惠',
 reason3Desc: '享受境外投资相关税收优惠政策，降低企业税务成本',
 reason4Title: '企业信誉',
 reason4Desc: '提升企业国际形象，增强海外合作伙伴信心',
 scopeTitle: '我们的服务范围',
 scopeSubtitle: '全流程专业服务，确保备案顺利完成',
 scope1Title: '前期咨询与评估',
 scope1Item1: '投资项目可行性分析',
 scope1Item2: '投资目的地选择建议',
 scope1Item3: '投资架构设计与优化',
 scope1Item4: '备案条件评估与风险分析',
 scope2Title: '备案申报服务',
 scope2Item1: '发改委境外投资项目备案',
 scope2Item2: '商务部门境外投资备案',
 scope2Item3: '外汇管理局登记备案',
 scope2Item4: '银行开户及资金出境协助',
 scope3Title: '材料准备与审核',
 scope3Item1: '备案申请文件准备',
 scope3Item2: '尽职调查报告撰写',
 scope3Item3: '投资方案编制',
 scope3Item4: '材料翻译与公证认证',
 scope4Title: '后续服务支持',
 scope4Item1: '年度报告和变更备案',
 scope4Item2: '境外企业运营指导',
 scope4Item3: '税务筹划与合规咨询',
 scope4Item4: '持续合规监测与提醒',
 processTitle: 'ODI备案办理流程',
 processSubtitle: '清晰透明的办理步骤，让您全程掌握进度',
 step1Title: '初步咨询',
 step1Desc: '了解客户投资需求，评估项目可行性，制定初步方案',
 step2Title: '资料准备',
 step2Desc: '指导客户准备备案所需材料，包括公司文件、投资计划等',
 step3Title: '发改委备案',
 step3Desc: '向省级发改委提交境外投资项目备案申请，获取项目备案通知书',
 step4Title: '商务部门备案',
 step4Desc: '向省级商务部门申请企业境外投资证书（ODI证书）',
 step5Title: '外汇登记',
 step5Desc: '到外汇管理局办理境外直接投资外汇登记手续',
 step6Title: '资金出境',
 step6Desc: '协助办理投资资金汇出手续，完成境外投资设立',
 step7Title: '后续服务',
 step7Desc: '提供年度报告、变更备案等持续合规服务',
 requirementsTitle: '备案基本要求',
 requirementsSubtitle: '满足以下条件，更易通过备案审批',
 companyRequirementsTitle: '企业条件',
 companyReq1: '境内企业成立满1年以上',
 companyReq2: '最近一年独立审计报告显示盈利',
 companyReq3: '净资产回报率不低于5%',
 companyReq4: '无重大违法违规记录',
 companyReq5: '具备相应的投资实力和管理能力',
 projectRequirementsTitle: '投资项目条件',
 projectReq1: '符合国家境外投资政策导向',
 projectReq2: '不属于限制或禁止类投资项目',
 projectReq3: '投资目的地国家政策稳定',
 projectReq4: '投资金额与企业实力相匹配',
 projectReq5: '具有明确的商业目的和投资计划',
 noticeTitle: '注意事项',
 notice1: '敏感国家和地区投资需特别审批（如涉及国家安全、军事等领域）',
 notice2: '房地产、酒店、影城、娱乐业、体育俱乐部等行业受到严格监管',
 notice3: '投资金额超过一定标准需国家发改委核准而非备案',
 notice4: '需要确保投资资金来源合法合规',
 ctaTitle: '专业ODI备案服务，助力企业出海',
 ctaDesc: '20余年专业经验，成功协助上百家企业完成ODI备案，让您的境外投资之路更加顺畅',
 viewMoreServices: '查看更多服务',
}
